'use client';

import { usePathname } from 'next/navigation';

import {
  AnalyticsPreferencesButton,
  MarketingAnalytics,
} from '../../app/(marketing)/_components/marketing-analytics';

export function AppMeasurement({ enabled }: { enabled: boolean }) {
  const pathname = usePathname();
  if (!enabled || !/^\/home(?:\/|$)/.test(pathname ?? '')) return null;
  return (
    <>
      <MarketingAnalytics production={enabled} audience="app" />
      <div className="bg-background text-muted-foreground fixed right-4 bottom-4 z-40 rounded-md border px-3 py-2 text-xs shadow-sm">
        <AnalyticsPreferencesButton />
      </div>
    </>
  );
}
